module.exports = __webpack_public_path__ + "media/mainvideo.432854fa.mp4";